import { addDays, isAfter, isBefore, startOfDay } from 'date-fns';
import { z } from 'zod';

import { SNOOZE_BO_TASK_MAX_DAYS, SNOOZE_BO_TASK_MIN_DAYS } from '@Common/constants';
import { ZodDateTimeString } from '@Common/types/zod/zod-date-string';

export const ZodBoTaskSnoozeUntil = z.union([ZodDateTimeString, z.literal('indefinite')]);

export const ZodBoTaskSnoozeUntilInput = ZodBoTaskSnoozeUntil.superRefine((value, ctx) => {
  if (value === 'indefinite') {
    return;
  }

  const dateValue = new Date(value);

  const min = startOfDay(addDays(new Date(), SNOOZE_BO_TASK_MIN_DAYS));
  if (isBefore(dateValue, min)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `Minimum snooze date is ${SNOOZE_BO_TASK_MIN_DAYS} days from now`,
    });
  }
  const max = startOfDay(addDays(new Date(), SNOOZE_BO_TASK_MAX_DAYS));
  if (isAfter(dateValue, max)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `Maximum snooze date is ${SNOOZE_BO_TASK_MAX_DAYS} days from now`,
    });
  }
});
